import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShovel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShovel"><Path d="M14.5 17.0818L6.91817 9.5C3.1272 13.2909 1.50267 15.9987 3.12737 20.8727C8.00134 22.4973 10.709 20.8727 14.5 17.0818Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 15.5L15.5 8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.8509 4.04067L17.5 2.5L21.5 6.5L19.9593 8.14911C18.8248 9.28363 16.9854 9.28363 15.8509 8.14911C14.7164 7.0146 14.7164 5.17518 15.8509 4.04067Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconShovel;
